import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IAddressState } from './address.state';

export class AddressSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly addressState = (state: IRootState): IAddressState => {
    return state.address as IAddressState;
  };

  static readonly model = createSelector(AddressSelectors.addressState, (address: IAddressState) => {
    return address.model;
  });

  static readonly data = createSelector(AddressSelectors.addressState, (address: IAddressState) => {
    return address.data;
  });
}
